import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, input } from '@angular/core';

export type AppButtonSeverity = 'primary' | 'secondary' | 'success' | 'danger' | 'warn' | 'info';
export type AppButtonVariant = 'solid' | 'outlined' | 'text';

@Component({
  selector: 'app-button',
  standalone: true,
  templateUrl: './app-button.component.html',
  styleUrl: './app-button.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppButtonComponent {
  readonly type = input<'button' | 'submit' | 'reset'>('button');
  readonly label = input('');
  readonly icon = input<string | null>(null);
  readonly severity = input<AppButtonSeverity>('primary');
  readonly variant = input<AppButtonVariant>('solid');
  readonly styleClass = input('');
  readonly size = input<'small' | 'normal'>('normal');
  readonly disabled = input(false, { transform: booleanAttribute });
  readonly loading = input(false, { transform: booleanAttribute });
  readonly rounded = input(false, { transform: booleanAttribute });
  readonly text = input(false, { transform: booleanAttribute });
  readonly fluid = input(false, { transform: booleanAttribute });

  protected iconName(): string {
    return this.icon()?.replace(/^app-icon app-icon-/, '') ?? '';
  }
}
